import { Button, FormField, FormInput, FormSelect } from "web-design-system";
import {
  FUND_BASKET_STRATEGY_OPTIONS,
  FUND_BASKET_TENURE_OPTIONS,
} from "creso-core/constants";
import { useFormContext } from "react-hook-form";
import { imageAssetUrl } from "@/utils/url";
import { FundBasketFormValues } from "./dialog";

export function BasketSetup(props: { next: () => void }) {
  const { next } = props;
  const form = useFormContext<FundBasketFormValues>();

  return (
    <div className="flex flex-col size-full">
      <div className="flex flex-col p-6 flex-1 gap-6">
        <div className="bg-slate-200 h-60 relative w-full aspect-video rounded-lg">
          <img
            className="w-60 h-40 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-[calc(50%-30px)]"
            src={imageAssetUrl("proposals/proposal-group.webp")}
          />
        </div>
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => <FormInput label="Name" {...field} />}
          />
          <FormField
            name="tenure"
            control={form.control}
            render={({ field }) => (
              <FormSelect
                {...field}
                options={
                  FUND_BASKET_TENURE_OPTIONS as unknown as Array<{
                    label: string;
                    value: string;
                  }>
                }
                placeholder="Select proposed time-frame"
                label="Tenure"
              />
            )}
          />
          <FormField
            control={form.control}
            name="strategy"
            render={({ field }) => (
              <FormSelect
                {...field}
                options={
                  FUND_BASKET_STRATEGY_OPTIONS as unknown as Array<{
                    label: string;
                    value: string;
                  }>
                }
                placeholder="Choose investment strategy"
                label="Strategy"
              />
            )}
          />
        </div>
      </div>
      <div className="p-5 border-t border-border flex justify-end items-center">
        <Button onClick={next}>Continue</Button>
      </div>
    </div>
  );
}
